import { combineReducers } from 'redux-immutable';
import { proceduresReducer } from 'iguazu-rpc';
import productsReducer from '@americanexpress/product-ducks';
import { resourcesReducer } from 'iguazu-rest';

export const reducer = combineReducers({
  procedures: proceduresReducer,
  products: productsReducer,
  resources: resourcesReducer,
});

export default reducer;
